var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.storeTva.state.tvas)?_c('v-data-table',{staticStyle:{"filter":"drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"},attrs:{"headers":_vm.headers,"items":_vm.storeTva.state.tvas.data},scopedSlots:_vm._u([{key:"item.purcentage",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.number)+"% ")]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_vm._t("action",null,{"item":item})]}}],null,true)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }